// extracted by mini-css-extract-plugin
module.exports = {"modalfooter":"styles_modalfooter___BBIe","fixed":"styles_fixed__CRXxE","message":"styles_message__MRupF"};